import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  flex: 1;
  background-color: transparent;
  flex-direction: row;

  gap:${RFValue(12)}px;
`;

export const StoresColumn = styled.View`
  flex-direction: column;
  gap:${RFValue(12)}px;
`;
